package com.dotdrives.design

enum class DotButtonVariant {
    Primary,
    Secondary,
    Tinted,
    Ink,
}

enum class DotTone {
    Neutral,
    Primary,
    Success,
    Info,
    Danger,
    Automation,
    Warning,
}
